import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../utils/AppUtils";
import {
  getLeaderBoardClear,
  getLeaderBoardReq,
  saveLeaderboard,
} from "../../redux/user/actions";
import _ from "lodash";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import {
  shareImage,
  shareImageResponseClear,
} from "../../redux/events/actions";
import CONFIG from "../../utils/config";
import Loader from "../Loader/Loader";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./SessionRescheduleComp.scss";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { use } from "i18next";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span
    className="shar-btn"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));
const SessionRescheduleComp = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const leaderBoardDataTestRes = useSelector((state) => state.user.leaderBoard);
  const saveLeaderboardRes = useSelector((state) => state.user.saveLeaderboardRes);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const imageUrlRes = useSelector((state) => state.events.shareImageRes);
  const userRole = useSelector((state) => state.user.role);
  const { t } = useTranslation();
  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [lastUpdateTime, setLastUpdateTime] = useState("");
  const [clickedShareBtn, setClickedShareBtn] = useState(0);

  const [fbTagetUrl, setfbTagetUrl] = useState();
  const [linkedinTargetUrl, setlinkedinTargetUrl] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [selectedOfficeList, setSelectedOfficeList] = useState([]);
  const [tabKey, setTabKey] = useState("last_month");
  const [parentTabKey, setParentTabKey] = useState("agents");
  const [isCheckedAnmos, setIsCheckedAnmos] = useState(false);
  const [isCheckedPublish, setIsCheckedPublish] = useState(false);
  const [isAllChecked, setIsAllChecked] = useState(true);
  const [rankSort, setRankSort] = useState("asc");

  useEffect(() => {
    getLeaderBoardData();
  }, [tabKey, parentTabKey]);

  useEffect(() => {
    // console.log('leaderBoardDataTestRes: ',leaderBoardDataTestRes);
    if (!_.isEmpty(leaderBoardDataTestRes)) {
      setIsLoading(false);
      if (leaderBoardDataTestRes?.status === "success") {
        let list = _.cloneDeep(leaderBoardDataTestRes?.payload?.payload?.list);
        let exclude_users = _.cloneDeep(leaderBoardDataTestRes?.payload?.payload?.exclude_users);
        let leaderboard_status = _.cloneDeep(leaderBoardDataTestRes?.payload?.payload?.leaderboard_status);
        setIsCheckedPublish(leaderboard_status?.publish_status === "yes" ? true : false);
        setIsCheckedAnmos(leaderboard_status?.anonymous_status === "yes" ? true : false);
        for (const item of list) {
          if (exclude_users && !_.isEmpty(exclude_users)) {
            item.isChecked = exclude_users?.includes(item.user_id) ? false : true;
          } else {
            item.isChecked = true;
          }


        }
        console.log("list: ", list);
        setLeaderBoardData(list);
        setLastUpdateTime(
          moment
            .unix(leaderBoardDataTestRes?.payload?.payload?.last_updated)
            .format("Do MMMM YYYY, h:mm A")
        );
        dispatch(getLeaderBoardClear());
      } else {
        setLeaderBoardData([]);
      }
    }
  }, [leaderBoardDataTestRes]);

  useEffect(() => {
    if (leaderBoardData.length > 0) {
      if (rankSort === "asc") {
        setLeaderBoardData(_.orderBy(leaderBoardData, ['rank'], ['asc']));
      } else {
        setLeaderBoardData(_.orderBy(leaderBoardData, ['rank'], ['desc']));
      }
    }
  }, [rankSort])

  let selectedOffice = [];
  selectedOfficeList.forEach((element) => {
    selectedOffice.push(element.office_id);
  });

  //get leader board
  const getLeaderBoardData = () => {
    setIsLoading(true);
    dispatch(
      getLeaderBoardReq({
        module: "leaderBoard",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          user_id: localStorage.getItem(SessionKeys.USER_ID),
          office_id: selectedOffice,
          tab: tabKey,
          filter_tab: parentTabKey
        },
      })
    );
  };

  useEffect(() => {
    if (clickedShareBtn > 0) {
      getBlobForAllEvents();
    }
  }, [clickedShareBtn]);

  const getBlobForAllEvents = () => {
    console.log("shareJson: ", leaderBoardData);
    let reqArr = [];
    for (let i = 0; i < leaderBoardData.length; i++) {
      const item = leaderBoardData[i];
      let tempObj = {
        name: item?.name,
        rank: item.rank,
        office: item.office,
        score: item?.score,
        profile: item.profile,
        is_me: item.is_me,
      };
      reqArr.push(tempObj);

      // if (i === 8) {
      //   break;
      // }
    }

    setIsLoading(true);
    dispatch(
      shareImage({
        module: "shareImageLeaderBoard",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          content_top: reqArr?.slice(0, 3),
          content_table:
            reqArr.length > 3 ? reqArr?.slice(3, reqArr.length) : [],
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(imageUrlRes)) {
      setIsLoading(false);
      if (imageUrlRes?.status === "success") {
        console.log("respo", imageUrlRes);
        setfbTagetUrl(imageUrlRes?.payload?.payload?.fb_target_url);
        setlinkedinTargetUrl(
          imageUrlRes?.payload?.payload?.linkedin_target_url
        );

        let pdfUrl =
          CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.pdf_url;
        let imgUrl =
          CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.data;
        let fbUrl = imageUrlRes?.payload?.payload?.fb_target_url;
        let linkedInUrl = imageUrlRes?.payload?.payload?.linkedin_target_url;
        console.log("responseShare", clickedShareBtn);

        let shareUrl =
          clickedShareBtn === 1
            ? pdfUrl
            : clickedShareBtn === 2
              ? imgUrl
              : clickedShareBtn === 3
                ? fbUrl
                : clickedShareBtn === 4
                  ? linkedInUrl
                  : "";

        if (clickedShareBtn > 0) {
          window.open(shareUrl, "_blank");
          setClickedShareBtn(0);
          dispatch(shareImageResponseClear());
        }
      }
    }
  }, [imageUrlRes, dispatch]);

  const saveLeaderboardReq = () => {
    let uncheckedList = [];
    for (const item of leaderBoardData) {
      if (!item.isChecked) {
        uncheckedList.push(item.user_id);
      }
    }
    setIsLoading(true);
    dispatch(
      saveLeaderboard({
        module: "saveLeaderboard",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          exclude_uids: uncheckedList,
          publish_status: isCheckedPublish ? "yes" : "no",
          anonymous_status: isCheckedAnmos ? "yes" : "no"
        },
      })
    );
  }


  useEffect(() => {
    if (!_.isEmpty(saveLeaderboardRes)) {
      setIsLoading(false);
      if (saveLeaderboardRes?.status === "success") {
        getLeaderBoardData();
      }
    }
  }, [saveLeaderboardRes])

  useEffect(() => {
    isAllCheckFunc();
  }, [leaderBoardData])

  const isAllCheckFunc = () => {
    let isAllCheck = true;
    for (const item of leaderBoardData) {
      if (!item.isChecked) {
        isAllCheck = false;
        break;
      }
    }
    setIsAllChecked(isAllCheck)
  }


  return (
    <>
      <Loader start={isLoading} />
      <div className="row">

        <div className="col-md-12 mb-3">
         

          
          <div className="lb-data my_courses">
            <div className="mb-3 d-flex justify-content-between isto gap-3 flex-column">
              <h4 className="requestheadineer d-flex  align-items-center mb-3 mt-3">
                {t("Booking Request")}
              </h4>
              <Tabs
                defaultActiveKey="last_month"
                id="justify-tab-example"
                justify
                onSelect={(k) => {
                  console.log("selectKey: ", k);
                  setTabKey(k);
                }}
              >
                <Tab eventKey="last_week" title={t("All")}></Tab>
                <Tab eventKey="last_month" title={t("Approved")}></Tab>
                <Tab eventKey="overall" title={t("Pending")}></Tab>
                <Tab eventKey="overall" title={t("Rejected")}></Tab>
              </Tabs>
            </div>

            <div className="lw-filters filters-leaderboard-cd">
              <div className="inner-content-caoch pt-4">
                <div className="s-earch-and-filters d-flex gap-4 justify-content-between mb-5">
                  <div className="search-filter position-relative">
                    <input
                      type="search"
                      placeholder={t("Search")}
                      id="inputPassword2"
                      className="form-control"
                    />
                    {false && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        // onClick={handleSearchClick}
                        className="cursor-pointer"
                      >
                        <path
                          d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z"
                          fill="black"
                        />
                      </svg>
                    )}
                  </div>

                </div>

              </div>

            </div>

            <div className="tab-leader-content">
              {leaderBoardData.length === 0 &&(
                <div className="col-md-12 notf-ound">
                  <div className="not-found mt-3">
                    <div className="interboxes">
                      <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" />
                      <p>{t("No request data yet.")}</p>
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-12">
                  <div className="responsive-carousel-points-table">
                    <div className="course-info-table">
                      {((parentTabKey === "agents" && authBroker.payload?.user.role.includes("program_manager")) || leaderBoardData.length > 3) && (
                        <table className="table mb-0 office_list table-striped video-list">
                          <thead className="position-relative">
                            <tr>
                              
                              <th
                                className={`text-rank cursor-pointer sortingtable ${rankSort}`}
                                scope="col"
                                style={{ Width: "100px" }}
                                onClick={() => {
                                  setRankSort(
                                    rankSort === "asc" ? "desc" : "asc"
                                  );
                                }}
                              >
                                {t("Ranking")}
                              </th>
                              <th
                                className="text-naem"
                                scope="col"
                                style={{ minWidth: "300px" }}
                              >
                                {t("Name")}
                              </th>
                              {false && (
                                <th
                                  className="text-role"
                                  scope="col"
                                  style={{ minWidth: "200px" }}
                                >
                                  {t("Role")}
                                </th>
                              )}
                              <th
                                className="text-left "
                                scope="col"
                                style={{ minWidth: "200px" }}
                              >
                                {t("Office")}
                              </th>
                              <th
                                className="text-left "
                                scope="col"
                                style={{ minWidth: "200px" }}
                              >
                                {t("learningPoints")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {leaderBoardData.length > 0 ? (
                              leaderBoardData.map((item, index) => {
                                return (
                                  <tr
                                    key={`lp-${1}`}
                                    className={item.is_me && "my-position"}
                                  >

                                    <td>{item?.rank}</td>
                                    <td className="text-name">
                                      <div className="d-flex gap-2 names-hw align-items-start">
                                        <img
                                          src={
                                            _.isEmpty(item?.profile)
                                              ? "/images/avatar.svg"
                                              : item?.profile
                                          }
                                          width={24}
                                          height={24}
                                        />
                                        <div className="name-sse">
                                          {item?.name}
                                        </div>
                                      </div>
                                    </td>
                                    {false && (
                                      <td className="text-date">
                                        {item?.role ? item?.role : "-"}
                                      </td>
                                    )}
                                    <td className="text-left">{item?.office}</td>
                                    <td className="text-left">{item?.score}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr className="not-found">
                                <td colSpan={5}>
                                  <img
                                    src="/images/finwell-img/NoSearchResults.svg"
                                    alt="Not Found"
                                  />
                                  <p>No leaderboard data yet.</p>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};
export default SessionRescheduleComp;
